
import HeroSection from '../../sections/HeroSection/HeroSection'
import Reservations from '../../components/Reservations/Reservations'
import MenuCard from '../../components/MenuCard/MenuCard'

import aboutBg from "../../assets/DimoraImages/image222.jpg";
import FoodGallery from '../../sections/FoodGallery/FoodGallery'


const MenuPage = () => {
    return (
        <div>
            <HeroSection backgroundImage={aboutBg} />
            <MenuCard />
            <Reservations />
            <FoodGallery/>
        </div>
    )
}

export default MenuPage